// extracted by mini-css-extract-plugin
module.exports = {"atm_jb_ucftp2":"atm_jb_ucftp2","atm_j3_ucftp2":"atm_j3_ucftp2","atm_gz_ftgil2":"atm_gz_ftgil2","atm_h0_ftgil2":"atm_h0_ftgil2"};